import grapesjs from 'drapcode-builder';
import loadTraits from './traits';

export default grapesjs.plugins.add('drapcode-carousel-traits', (editor, opts = {}) => {
  const default_labels = {
    carousel: 'Carousel',
    carousel_item: 'Carousel Item',
    carousel_list_item: 'Carousel List Item',
  };
  const default_types = {
    carousel_container: 'carousel-container',
    carousel_item: 'carousel-item',
    carousel_list_item: 'carousel-list-item',
  };
  let options = {
    ...{
      labels: default_labels,
      types: default_types,
    },
    ...opts,
  };

  loadTraits(editor, options);
});
